function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import Bulma from '../core';
import Plugin from '../plugin';
/**
 * @module Tabs
 * @since  0.4.0
 * @author  Thomas Erbe <vizuaalog@gmail.com>
 */

var Tabs = /*#__PURE__*/function (_Plugin) {
  _inherits(Tabs, _Plugin);

  var _super = _createSuper(Tabs);

  /**
   * Plugin constructor
   * @param  {Object} options The options object for this plugin
   * @return {this} The newly created instance
   */
  function Tabs(options) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _super.call(this, options);
    /**
     * The root tab element
     * @param {HTMLElement}
     */

    _this.element = _this.option('element');

    _this.element.setAttribute('data-bulma-attached', 'attached');
    /**
     * Whether the tabs should be changed when the nav item is hovered over
     * @param {boolean}
     */


    _this.hover = _this.option('hover');
    /**
     * The tab nav container
     * @param {HTMLElement}
     */

    _this.nav = _this.findNav();
    /**
     * The tab's nav items
     * @param {HTMLElement[]}
     */

    _this.navItems = _this.findNavItems();
    /**
     * The tab content container
     * @param {HTMLElement}
     */

    _this.content = _this.findContent();
    /**
     * The tab's content items
     * @param {HTMLElement[]}
     */

    _this.contentItems = _this.findContentItems();

    _this.setupNavEvents();

    return _this;
  }
  /**
   * Find the tab navigation container.
   * @returns {HTMLElement} The navigation container
   */


  _createClass(Tabs, [{
    key: "findNav",
    value: function findNav() {
      return this.element.querySelector('.tabs');
    }
    /**
     * Find each individual tab item
     * @returns {HTMLElement[]} An array of the found items
     */

  }, {
    key: "findNavItems",
    value: function findNavItems() {
      return this.nav.querySelectorAll('li');
    }
    /**
     * Find the tab content container.
     * @returns {HTMLElement} The content container
     */

  }, {
    key: "findContent",
    value: function findContent() {
      return this.element.querySelector('.tabs-content');
    }
    /**
     * Find each individual content item
     * @returns {HTMLElement[]} An array of the found items
     */

  }, {
    key: "findContentItems",
    value: function findContentItems() {
      // We have to use the root here as the querySelectorAll API doesn't
      // support using '>' as the first character. So we have to have a
      // class to start with.
      return this.element.querySelectorAll('.tabs-content > ul > li');
    }
    /**
     * Setup the events to handle tab changing
     * @returns {void}
     */

  }, {
    key: "setupNavEvents",
    value: function setupNavEvents() {
      var _this2 = this;

      Bulma.each(this.navItems, function (navItem, index) {
        navItem.addEventListener('click', function () {
          _this2.handleNavClick(navItem, index);
        });

        if (_this2.hover) {
          navItem.addEventListener('mouseover', function () {
            _this2.handleNavClick(navItem, index);
          });
        }
      });
    }
    /**
     * Handle the changing of the visible tab
     * @param {HTMLelement} navItem The nav item we are changing to
     * @param {number} index The internal index of the nav item we're changing to
     * @returns {void}
     */

  }, {
    key: "handleNavClick",
    value: function handleNavClick(navItem, index) {
      Bulma.each(this.navItems, function (navItem) {
        navItem.classList.remove('is-active');
      });
      Bulma.each(this.contentItems, function (contentItem) {
        contentItem.classList.remove('is-active');
      });
      navItem.classList.add('is-active');
      this.contentItems[index].classList.add('is-active');
    }
  }], [{
    key: "create",
    value:
    /**
     * Helper method used by the Bulma core to create a new instance.
     * @param  {Object} options The options object for this instance
     * @returns {Tabs} The newly created instance
     */
    function create(options) {
      return new Tabs(options);
    }
    /**
     * Handle parsing the DOMs data attribute API.
     * @param {HTMLElement} element The root element for this instance
     * @returns {undefined}
     */

  }, {
    key: "parse",
    value: function parse(element) {
      var hover = element.hasAttribute('data-hover') ? true : false;
      var options = {
        element: element,
        hover: hover
      };
      new Tabs(options);
    }
    /**
     * The root class used for initialisation
     * @returns {string} The class this plugin is responsible for
     */

  }, {
    key: "getRootClass",
    value: function getRootClass() {
      return 'tabs-wrapper';
    }
    /**
     * Returns an object containing the default options for this plugin.
     * @returns {object} The default options object.
     */

  }, {
    key: "defaultOptions",
    value: function defaultOptions() {
      return {
        hover: false
      };
    }
  }]);

  return Tabs;
}(Plugin);

Bulma.registerPlugin('tabs', Tabs);
export default Tabs;